import React, { FC } from 'react';
import { Modal, Content, InfoIcon, Text } from './styles';
import { Props } from './types';

const ForgetPasswordModal: FC<Props> = ({ open, handleCloseModal }) => {
  return (
    <Modal open={open} handleClose={handleCloseModal}>
      <Content>
        <InfoIcon />
        <Text>Please call Superorder Support to reset your password!</Text>
      </Content>
    </Modal>
  );
};

export default ForgetPasswordModal;

// TODO: TFR-29 add story to component
// TODO: TFR-44 move to modals group
